import { createSearchParamsContext } from 'src/app/shared/contexts/SearchParamsContext'

// Create File Mapping Setup search params context
const { Provider, useContext } = createSearchParamsContext(
  'bfa_file_mapping_setup_search_params',
  'FileMappingSetupFilters'
)

export const FileMappingSetupFiltersProvider = Provider
export const useFileMappingSetupFilters = useContext
